import type React from 'react';
import { useDrag } from 'react-dnd';
import { useRef } from 'react';
import { Paragraph } from '../..';
import IcoDrag from '../../icon/icons/IcoDrag';
import IcoShape from '../../icon/icons/IcoShape';
import './blockSourceButton.less';

interface ShapeBlockButtonProps {
  title: string;
  onClickAdd?: () => void;
}

const ShapeBlockButton: React.FunctionComponent<ShapeBlockButtonProps> = ({ title, onClickAdd }) => {
  const wasDraggingRef = useRef(false);
  const [{ isDragging }, drag] = useDrag(() => ({
    type: 'SHAPE',
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
    item: () => {
      wasDraggingRef.current = true;
      return { title };
    },
    end: () => {
      requestAnimationFrame(() => {
        wasDraggingRef.current = false;
      });
    },
  }));

  const handleClick = () => {
    if (wasDraggingRef.current) return;
    onClickAdd?.();
  };

  return (
    <button ref={drag} draggable className="block-source" style={{ opacity: isDragging ? 0.5 : 1 }} onClick={handleClick}>
      <div className="block-source-icon">
        <IcoShape style={{ fill: 'none' }} />
      </div>
      <div className="block-source-drag-icon">
        <IcoDrag />
      </div>
      <Paragraph size="sm">{title}</Paragraph>
    </button>
  );
};

export default ShapeBlockButton;
ShapeBlockButton.displayName = 'ShapeBlockButton';
